var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"spikePart2"}},_vm._l((_vm.list),function(item,index){return _c('spikePart2Item',{key:index,attrs:{"items":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }